module.exports = __webpack_public_path__ + "static/media/actors.b408ca03.png";